import React from "react";
import { CustomDatePicker, CustomTimePicker } from "./CustomPickers";

/**
 * DateTimePicker - cross-browser custom picker (no native datepicker).
 * value: "YYYY-MM-DDTHH:MM" string (datetime-local format)
 * onChange: receives the combined "YYYY-MM-DDTHH:MM" string
 */
export const DateTimePicker = ({ value, onChange, testId, disabled = false }) => {
    const splitValue = (v) => {
        if (!v) return { date: "", time: "" };
        const cleaned = v.includes("T") ? v : v.replace(" ", "T");
        const parts = cleaned.split("T");
        return { date: parts[0] || "", time: (parts[1] || "").slice(0, 5) };
    };

    const { date, time } = splitValue(value);

    const update = (newDate, newTime) => {
        if (!newDate && !newTime) {
            onChange("");
            return;
        }
        onChange(`${newDate || date || ""}T${newTime || time || "00:00"}`);
    };

    return (
        <div className="grid grid-cols-2 gap-2">
            <CustomDatePicker
                testId={testId ? `${testId}-date` : undefined}
                value={date}
                onChange={(v) => update(v, time)}
                disabled={disabled}
            />
            <CustomTimePicker
                testId={testId ? `${testId}-time` : undefined}
                value={time}
                onChange={(v) => update(date, v)}
                disabled={disabled}
            />
        </div>
    );
};
